import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { UserSessionService } from './user-session.service';
import { ApiService, URLS } from './api.service';
import { UserStorageService } from './user-storage.service';
import { Agente } from 'app/models/agente';

declare var $: any;

@Injectable()
export class AgenteService {

  constructor(private http: HttpClient, private userService: UserStorageService,private apiService: ApiService)
  {

  }

  private httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};



  getAgentes(){
    this.apiService.get(URLS.AGENTES.GET_AGENTES, '', environment.urlLaravel)
    .subscribe(
      function (data) {
        console.log(data)
        return data;
      },
      function (error) {
        console.log(error);
      });
  }

  getAgentePorUserId(){

    var user = this.userService.getUser()

    this.apiService.get(URLS.AGENTES.GET_AGENTES_USUARIOS, user.id , environment.urlLaravel)
    .subscribe(
      function (data) {
        console.log(data)
        return data;
      },
      function (error) {
        console.log(error);
      });
  }

  getAgente(matricula){
    return this.apiService.get(URLS.AGENTES.GET_AGENTES_POR_MATRICULA, matricula, environment.urlLaravel);

  }

  getAgenteSeg(matricula){
    return this.apiService.post(URLS.AGENTES.POST_AGENTES_POR_MATRICULA +'/'+ matricula , "", environment.urlLaravel);

  }

  getAgenteID(id){
    return this.apiService.get(URLS.AGENTES.GET_AGENTES_POR_ID, id, environment.urlLaravel);

  }

  getAgentePorUUID(uuid){
    let params = {
      'chave': uuid
    };
    return this.apiService.post(URLS.AGENTES.POST_AGENTES_POR_CHAVE, params, environment.urlLaravel);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/agente.service.ts